import { useEffect, useState } from 'react';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { useLayout } from '../../context/LayoutContext';
import config from '../../data/config';
const Confirmation = () => {
  const navigate = useNavigate();
  const { setFooterContent } = useLayout();
  const [processingButtons, setProcessingButtons] = useState<{[key: string]: boolean}>({
    register: false,
  });
  
  // const isInterviewComplete = sessionStorage.getItem('interviewComplete') === 'true';

  // Prevent back navigation
  useEffect(() => {

    // Disable the back button
    // window.history.pushState(null, '', window.location.pathname);
    // const handlePopState = () => {
    //   window.history.pushState(null, '', window.location.pathname);
    //   // Optional: Show a message that going back isn't allowed
    //   alert("You've already submitted your interview. Please close this tab.");
    // };
    // window.addEventListener('popstate', handlePopState);
    // return () => {
    //   window.removeEventListener('popstate', handlePopState);
    // };
  }, []);

  // load hotjar tracking onMount AS-3104
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6389465,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(script);
    
    // Cleanup on unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  

  const handleClose = () => {
    navigate('/interview');
  };
  
  const handleRegister = async () => {
    await new Promise(resolve => setTimeout(resolve, 250));
    window.open(config.JOBSEEKER_API_URL, '_blank');
  };

  const handleButtonClick = (button: string, onClick: () => void) => {
    setProcessingButtons(prev => ({ ...prev, [button]: true }));
    onClick();
    setProcessingButtons(prev => ({ ...prev, [button]: false }));
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
        minHeight: 'calc(100vh - 250px)', 
      }}
    >
      <img
        src="/svgs/done.svg"
        alt="Success"
        style={{
          marginBottom: '2rem',
        }}
      />
      <h2
        style={{
          fontWeight: 500,
          fontSize: '1.2rem',
          whiteSpace: 'nowrap',
          textAlign: 'center',
        }}
      >
        Interview Successfully Completed
      </h2>{' '}
      <p style={{ fontSize: '0.9rem', color: '#6c757d' }}>Thank you! You can close this tab, or please consider registering as a Jobseeker with JobTarget!</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <Button showSpinner={processingButtons.register} text="Register as a Jobseeker" variant="primary" onClick={() => handleButtonClick('register', handleRegister)} />
      </div>
    </div>
  );
};

export default Confirmation;
